export interface PricingTier {
  id: string;
  label: string;
  maxEmails: number;
  price: number;
  pricePerEmail: number;
  popular?: boolean;
}

export const PRICING_TIERS: PricingTier[] = [
  {
    id: '1-email',
    label: '1 adresse',
    maxEmails: 1,
    price: 25000,
    pricePerEmail: 25000,
  },
  {
    id: '3-emails',
    label: '3 adresses',
    maxEmails: 3,
    price: 40000,
    pricePerEmail: Math.round(40000 / 3),
    popular: true,
  },
  {
    id: '10-emails',
    label: '10 adresses',
    maxEmails: 10,
    price: 60000,
    pricePerEmail: Math.round(60000 / 10),
  },
];

export const CURRENCY = 'XOF';

export function getMatchingTier(emailCount: number): PricingTier | null {
  if (emailCount <= 0) return null;
  // Find the smallest tier that fits
  for (const tier of PRICING_TIERS) {
    if (emailCount <= tier.maxEmails) return tier;
  }
  // Beyond 10: custom pricing
  return null;
}

export function calculatePrice(emailCount: number): { price: number; tier: PricingTier | null; isCustom: boolean } {
  if (emailCount <= 0) return { price: 0, tier: null, isCustom: false };

  const tier = getMatchingTier(emailCount);
  if (tier) {
    return { price: tier.price, tier, isCustom: false };
  }

  // Custom: above 10 emails → base 60000 + 5000 per extra email
  const extraEmails = emailCount - 10;
  const price = 60000 + extraEmails * 5000;
  return { price, tier: null, isCustom: true };
}

export function formatPrice(price: number): string {
  return `${price.toLocaleString('fr-FR')} ${CURRENCY}`;
}